module.exports = __webpack_public_path__ + "1-18.png?8f322bbd20b1b1712fc920dbd3115f98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-18.png
// module id = 95
// module chunks = 0